<template>
  <DashboardHeader title="Manage Site">
    <DashboardTiles :tiles="tiles"></DashboardTiles>
  </DashboardHeader>
</template>

<script>
import DashboardTiles from "@/components/myLibrary/DashboardTiles.vue";
import DashboardHeader from "@/components/DashboardHeader.vue";
export default {
  components: { DashboardTiles, DashboardHeader },

  data() {
    return {
      tiles: [
        // {
        //   id: 1,
        //   icon: "mdi-cog",
        //   title: "Company",
        //   description: "",
        //   industry: ["Legal Practice", "General"],
        //   route: "crud-website-data",
        //   param: "",
        //   alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter",
        // },
        // },
        // {
        //   id: 1,
        //   icon: "mdi-format-wrap-tight",
        //   title: "Manage Posts",
        //   description: "",
        //   industry: ["Legal Practice", "General"],
        //   route: "website-manage-posts",
        //   param: "",
        //   alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        //   buttonText: "Enter",
        // },
        {
          id: 2,
          icon: "mdi-folder-multiple-image",
          title: "Images",
          description: "",
          industry: ["Agency", "Legal Practice", "General"],
          route: "manage-images",
          param: "",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
          buttonText: "Enter",
        },
      ],
    };
  },
};
</script>

<style></style>
